<template>
  <form @submit.prevent="submit">
    <PageHeader>
      <div class="heading">
        <h1>
          The Lock Screen
        </h1>
      </div>
    </PageHeader>

    <div class="helper-text">
      <p>Would you like to allow the public to access your website? If you'd prefer to prevent access to a particular page, you can set a password to that instead.</p>
    </div>

    <hr>

    <div class="visibility-wrapper">
      <Field
        label="Allow Public Access"
        type="checkbox"
        @input="$v.resource.active.touch()"
        @handleChange="handleChange"
        v-model="resource.active"
        :error="activeError"/>

      <div class="btn-save">
        <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
      </div>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'
import PageHeader from '@/components/PageHeader'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'SiteActiveForm',

  mixins: [form],

  components: {
    Btn,
    PageHeader
  },

  computed: {
    ...errorMessages([
      'active'
    ])
  },

  validations: {
    resource: {
      active: {required}
    }
  }
}
</script>

<style lang="sass">
  .visibility-wrapper
</style>
